import { techniqueConstants } from "../constants/techniques.constants";

const initialState = {
  loading: false,
  data: null,
  error: false,
};

export default function techniquesReducer(state = initialState, action) {
  switch (action.type) {
    case techniqueConstants.TECHNIQUES_LOADING:
      return {
        ...state,
        loading: true,
        error: false,
      };

    case techniqueConstants.TECHNIQUES_LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case techniqueConstants.TECHNIQUES_LOAD_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
}
